//Permite cargar siempre los componetes internos 

const Auxiliar = (propiedades) => propiedades.children

export default Auxiliar;